$(document).on('turbolinks:load', function() {
    const prefectureSelect = $('.search-field select[name="prefecture"]');
    const citySelect = $(".search-field select[name='city']");

    // reset city field when prefecture changes
    const loadCities = (prefectureId, cityId) => {
        const selectedPrefectureName = prefectureSelect.find("option:selected").text();

        citySelect.empty(); // Clear city field first

        if (["全国", "海外", "その他", "未選択"].includes(selectedPrefectureName)) {
            citySelect.prop("disabled", true);
            citySelect.addClass('disabled');
        } else {
            citySelect.prop("disabled", false);
            citySelect.removeClass('disabled');
            $.ajax({
                url: "/subsidy/cities/get_cities",
                method: "GET",
                data: {prefecture_id: prefectureId},
                dataType: "json"
            }).done((data) => {
                citySelect.append($("<option>").val('').text("全域"));
                $.each(data, (i, city) => {
                    citySelect.append('<option value="' + city.id + '">' + city.name + '</option>');
                });
                if (cityId) {
                    citySelect.val(cityId);
                }
            });
        }
    }

    prefectureSelect.change(() => {
        loadCities(prefectureSelect.val());
    });

    // Here, you load the initial cities based on the saved prefecture, if it exists
    const savedPrefecture = localStorage.getItem("prefecture");
    if (savedPrefecture) {
        prefectureSelect.val(savedPrefecture);
        loadCities(savedPrefecture, localStorage.getItem("city"));
    }

    // set keyword field value from localStorage
    const keyword = localStorage.getItem("keyword");
    if (keyword) {
        $('input[name="keyword"]').val(keyword);
    }

    // set target_users field value from localStorage
    const targetUsers = JSON.parse(localStorage.getItem("targetUsers"));
    if (targetUsers) {
        targetUsers.forEach(function(userId) {
            $(`input[name="target_users[]"][value="${userId}"]`).prop('checked', true);
        });
    }

    // set target_items field value from localStorage
    const targetItems = JSON.parse(localStorage.getItem("targetItems"));
    if (targetItems) {
        targetItems.forEach(function(itemId) {
            $(`input[name="target_items[]"][value="${itemId}"]`).prop('checked', true);
        });
    }

    // set target_purposes field value from localStorage
    const targetPurposes = JSON.parse(localStorage.getItem("targetPurposes"));
    if (targetPurposes) {
        targetPurposes.forEach(function(purposeId) {
            $(`input[name="target_purposes[]"][value="${purposeId}"]`).prop('checked', true);
        });
    }

    // set expand_search field value from localStorage
    const expandSearch = JSON.parse(localStorage.getItem("expandSearch"));
    if (expandSearch) {
        $('input[name="expand_search"]').prop('checked', true);
    } else {
        $('input[name="expand_search"]').prop('checked', false);
    }

    // set include_unknown_period field value from localStorage
    const includeUnknownOrClosed = JSON.parse(localStorage.getItem("includeUnknownOrClosed"));
    if (includeUnknownOrClosed === false) {
        $('input[name="include_unknown_or_closed"]').prop('checked', false);
    } else {
        $('input[name="include_unknown_or_closed"]').prop('checked', true);
    }

    // store search parameters to localStorage
    $('.search-field').on('submit', function(e) {
        e.preventDefault();
        // keyword
        let keywordField = $(this).find('input[name="keyword"]');
        if (keywordField.length > 0) {
            let keyword = keywordField.val().trim();
            if (keyword) {
                localStorage.setItem("keyword", keyword);
            } else {
                keywordField.removeAttr('name');
                localStorage.removeItem("keyword");
            }
        } else {
            localStorage.removeItem("keyword");
        }

        // prefecture
        const prefecture = $(this).find('select[name="prefecture"]').val();
        if (prefecture) {
            localStorage.setItem("prefecture", prefecture);
        } else {
            localStorage.removeItem("prefecture");
        }

        // city
        const city = $(this).find('select[name="city"]').val();
        localStorage.setItem("city", city);

        // target_users
        const targetUsers = $(this).find('input[name="target_users[]"]:checked').map(function(){ return this.value; }).get();
        localStorage.setItem("targetUsers", JSON.stringify(targetUsers));

        // target_items
        const targetItems = $(this).find('input[name="target_items[]"]:checked').map(function(){ return this.value; }).get();
        localStorage.setItem("targetItems", JSON.stringify(targetItems));

        // target_purposes
        const targetPurposes = $(this).find('input[name="target_purposes[]"]:checked').map(function(){ return this.value; }).get();
        localStorage.setItem("targetPurposes", JSON.stringify(targetPurposes));

        // expand search
        const isExpandSearchChecked = $(this).find('input[name="expand_search"]').prop("checked");
        if (isExpandSearchChecked) {
            localStorage.setItem("expandSearch", "true");
        } else {
            localStorage.removeItem("expandSearch");
        }

        // include unknown period
        const isIncludeUnknownOrClosed = $(this).find('input[name="include_unknown_or_closed"]').prop("checked");
        if (isIncludeUnknownOrClosed === false) {
            localStorage.setItem("includeUnknownOrClosed", isIncludeUnknownOrClosed);
        } else {
            localStorage.removeItem("includeUnknownOrClosed");
        }

        // no send city field when city is 全域
        let citySelect = $(this).find('select[name="city"]');
        if (citySelect.find('option:selected').text().includes('全域')) {
            citySelect.removeAttr('name');
        }

        // no send prefecture field when prefecture is 未選択
        let prefectureSelect = $(this).find('select[name="prefecture"]');
        if (prefectureSelect.find('option:selected').text().includes('未選択')) {
            prefectureSelect.removeAttr('name');
        }

        // disable search button
        const searchButton = $(this).find('.search-btn');
        searchButton.prop('disabled', true);
        searchButton.find('.spinner-border').removeClass('d-none');
        searchButton.text(' 検索中...');

        e.target.submit();
    });

    // clear search parameters
    $('.clear-search-condition').on('click', function(e) {
        e.preventDefault();

        // delete localStorage
        localStorage.removeItem("keyword");
        localStorage.removeItem("prefecture");
        localStorage.removeItem("city");
        localStorage.removeItem("targetUsers");
        localStorage.removeItem("targetItems");
        localStorage.removeItem("targetPurposes");
        localStorage.removeItem("expandSearch");
        localStorage.removeItem("includeUnknownOrClosed");

        // reset each form
        $('.search-form').each(function() {
            this.reset();
        });

        citySelect.empty();
    });
});
